module.exports = __webpack_public_path__ + "img/bridge_brand_logo.e0a7ffd8.png";